export function newMenuItemId() {
    return `menu-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}

export function defaultFileRow() {
    return {
        id: Date.now() + Math.random(),
        file: '',
        rx: '0',
        tx: '0',
        startDay: '2',
        endDay: '1',
        startHour: '00',
        startMinute: '00',
        endHour: '23',
        endMinute: '59',
        is_order: 0,
    }
}

export function createEmptyMenuItem() {
    return {
        id: newMenuItemId(),
        shortNumberName: '',
        shortNumber: '',
        noAnswerShort: '',
        is_order: 0,
        send_mail: [],
        is_menu: 0,
        menu: [],
        filesUiVisible: false,
        files: [defaultFileRow()],
    }
}

export function defaultMenuTree() {
    return [createEmptyMenuItem()]
}

export function normalizeFileRowFromApi(item) {
    if (!item || typeof item !== 'object') return defaultFileRow()
    const daysParts = item.days ? item.days.split('-') : ['2', '1']
    const hoursParts = item.hours ? item.hours.split(/[:-]/) : ['00', '00', '23', '59']
    return {
        id: item.id || Date.now() + Math.random(),
        file: item.buddy || item.file || '',
        rx: item.rx || '0',
        tx: item.tx || '0',
        startDay: daysParts[0] || '2',
        endDay: daysParts[1] || '1',
        startHour: hoursParts[0] || '00',
        startMinute: hoursParts[1] || '00',
        endHour: hoursParts[2] || '23',
        endMinute: hoursParts[3] || '59',
        is_order: item.is_order || 0,
    }
}

export function normalizeMenuItemFromApi(row) {
    if (!row || typeof row !== 'object') return createEmptyMenuItem()
    const legacy = row.key !== undefined && row.dest !== undefined && !Array.isArray(row.files)
    const base = createEmptyMenuItem()
    if (legacy) {
        return {
            ...base,
            id: row.id || newMenuItemId(),
            shortNumber: String(row.key ?? ''),
            noAnswerShort: row.dest ?? '',
            shortNumberName: row.name || row.label || '',
            filesUiVisible: true,
        }
    }
    const sendMailArray = row.send_mail
        ? (Array.isArray(row.send_mail) ? row.send_mail : String(row.send_mail).split(',').map((m) => m.trim()).filter(Boolean))
        : []
    let filesData = []
    if (Array.isArray(row.files) && row.files.length) {
        filesData = row.files.map((f) => normalizeFileRowFromApi(f))
    } else {
        filesData = [defaultFileRow()]
    }
    return {
        ...base,
        ...row,
        id: row.id || newMenuItemId(),
        send_mail: sendMailArray,
        menu: Array.isArray(row.menu) ? row.menu.map((c) => normalizeMenuItemFromApi(c)) : [],
        files: filesData,
        is_order: row.is_order ?? 0,
        is_menu: row.is_menu != null && !Number.isNaN(Number(row.is_menu)) ? Number(row.is_menu) : 0,
        filesUiVisible: row.filesUiVisible === false ? false : true,
    }
}

export function normalizeMenuTree(rows) {
    if (!Array.isArray(rows)) return []
    return rows.map((r) => normalizeMenuItemFromApi(r))
}

export function getMenuArrayAtPath(formMenu, pathToParent) {
    if (!Array.isArray(formMenu)) return []
    let cur = formMenu
    for (const idx of pathToParent) {
        const node = cur[idx]
        if (!node) return []
        cur = Array.isArray(node.menu) ? node.menu : []
    }
    return cur
}

export function setMenuChildrenAtPath(formMenu, pathToParent, newChildren) {
    if (!Array.isArray(formMenu)) formMenu = []
    if (pathToParent.length === 0) return newChildren
    const [head, ...rest] = pathToParent
    return formMenu.map((item, i) => {
        if (i !== head) return item
        const sub = Array.isArray(item.menu) ? item.menu : []
        if (rest.length === 0) return { ...item, menu: newChildren }
        return { ...item, menu: setMenuChildrenAtPath(sub, rest, newChildren) }
    })
}

export function updateMenuItemAtPath(formMenu, itemPath, updater) {
    if (!itemPath.length) return formMenu
    const [head, ...rest] = itemPath
    if (rest.length === 0) {
        return formMenu.map((item, i) => (i === head ? updater(item) : item))
    }
    return formMenu.map((item, i) => {
        if (i !== head) return item
        const sub = Array.isArray(item.menu) ? item.menu : []
        return { ...item, menu: updateMenuItemAtPath(sub, rest, updater) }
    })
}

export function assignShortNumbersTree(items) {
    return (items || []).map((item, idx) => ({
        ...item,
        shortNumber: String(idx + 1),
        menu: assignShortNumbersTree(item.menu || []),
    }))
}
